<template>
  <div class="pb-dashboard-column">
    <v-layout
      :class="{
        'white--text': $vuetify.theme.dark,
      }"
      class="pb-dashboard-column-title"
      justify-center
      column
    >
      <v-layout
        class="pb-dashboard-column-title-text"
        justify-center
        align-center
      >
        <slot name="title">
          {{ title }}
        </slot>
      </v-layout>
    </v-layout>

    <v-layout
      class="pb-dashboard-column-body"
      justify-center
      align-center
      column
    >
      <slot />
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'PbDashboardColumn',

  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="css" scoped>
.pb-dashboard-column {
  min-width: 340px;
  margin: 25px 0 25px 10px;
}

.pb-dashboard-column .pb-dashboard-column-title::before {
  content: '';
  width: 100%;
  height: 4px;
  background: #5f5f5f3d;
}

.pb-dashboard-column .pb-dashboard-column-title::after {
  content: '';
  width: 100%;
  height: 2px;
  background: #5f5f5f3d;
}

.pb-dashboard-column .pb-dashboard-column-title .pb-dashboard-column-title-text {
  padding: 5px;
}

.pb-dashboard-column .pb-dashboard-column-body {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0 2px 0;
}

</style>
